import './FloatingText.scss';

import { defineComponent, h, PropType } from 'vue';

type Variant = '' | 'brand' | 'danger' | 'ok';

export default defineComponent({
    props: {
        variant: {
            required: false,
            default: '',
            type: String as PropType<Variant>,
        },
    },

    render() {
        return h('span', {
            class: {
                'floating-text': this.variant === '',
                'floating-text-brand': this.variant === 'brand',
                'floating-text-danger': this.variant === 'danger',
                'floating-text-ok': this.variant === 'ok',
            },
        }, this.$slots.default ? this.$slots.default() : '');
    },
});
